import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { ScreenContainer, ContentFrame } from '@pinwheel/origami';
import { useAppDispatch } from '../../state';
import { initializeBillSwitch, next, selectJobType, selectLinkApiResponse, waitForJobStepResults, } from '../../state/slices/slice-link-api';
import LoadingView from '../../views/Loading';
import JobTemplate from '../../LinkApiRouter/views/JobTemplate';
import useLinkNavigate from '../../hooks/useLinkNavigate';
import ModalHeader from '../../components/ModalHeader';
import useIsLinkApiLoading from '../../hooks/useIsLinkApiLoading';
import { setError } from '../../state/slices/slice-error';
var BillSwitch = function () {
    var dispatch = useAppDispatch();
    var navigate = useLinkNavigate();
    var linkApiResponse = useSelector(selectLinkApiResponse);
    var jobType = useSelector(selectJobType);
    useEffect(function () {
        void dispatch(initializeBillSwitch());
    }, [dispatch]);
    useEffect(function () {
        if (jobType !== 'bill_switch') {
            return;
        }
        if (!linkApiResponse)
            return;
        if (linkApiResponse.responseType === 'next')
            return;
        if (linkApiResponse.responseType === 'processing') {
            void dispatch(waitForJobStepResults());
        }
        else if (linkApiResponse.responseType === 'success') {
            navigate('/success');
        }
        else if (linkApiResponse.responseType === 'pending_retry') {
            dispatch(setError({
                type: linkApiResponse.error.type,
                code: linkApiResponse.error.code,
                message: linkApiResponse.error.message,
                pendingRetry: true,
            }));
            navigate('/error');
        }
        else if (linkApiResponse.responseType === 'error' ||
            linkApiResponse.responseType === 'next_with_error') {
            dispatch(setError({
                type: linkApiResponse.error.type,
                code: linkApiResponse.error.code,
                message: linkApiResponse.error.message,
                pendingRetry: false,
            }));
            if (linkApiResponse.responseType === 'error') {
                navigate('/error');
            }
        }
    }, [linkApiResponse, dispatch, jobType]); // eslint-disable-line react-hooks/exhaustive-deps
    var isLoading = useIsLinkApiLoading();
    var willRouteToError = linkApiResponse &&
        (linkApiResponse.responseType === 'error' ||
            linkApiResponse.responseType === 'pending_retry');
    return isLoading || willRouteToError ? (React.createElement(LoadingView, { hideModalHeader: true })) : (React.createElement(ScreenContainer, { "data-testid": "linkApi/bill-switch" },
        React.createElement(ModalHeader, { showPlatformLogo: true }),
        React.createElement(ContentFrame, null,
            React.createElement(JobTemplate, { linkApiResponse: linkApiResponse, submitStep: function (payload) {
                    return dispatch(next({
                        payload: payload,
                    }));
                } }))));
};
export default BillSwitch;
